module.exports = __webpack_public_path__ + "static/determined-site-header-cu-ch-2accbd5bcba43ce416ebf889459c05bf.jpg";